import useAppendFilter from "components/common/PaginatedEntityTable/hooks/useAppendFilter";
const useAppendTagFilter = () => useAppendFilter("tags");
export default useAppendTagFilter;
